// Script para crear las 10 categorías completas del sistema
export {};

(window as any).createAll10Categories = async function() {
  console.log('🚀 Creando las 10 categorías completas del sistema...');
  
  try {
    // Verificar que Firebase esté disponible
    if (!(window as any).auth) {
      throw new Error('Firebase no está disponible');
    }
    
    const { db, collection, doc, setDoc, serverTimestamp } = (window as any).auth;
    
    // Obtener el ID del usuario actual
    const userId = (window as any).auth.auth.currentUser?.uid;
    if (!userId) {
      throw new Error('Usuario no autenticado');
    }

    console.log(`👤 Usuario: ${userId}`);

    // Las 10 categorías completas del sistema
    const allCategories = {
      'REMERA': {
        name: 'REMERA',
        fields: {
          talle: {
            type: 'select',
            options: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', 'Único'],
            multiple: true,
            required: true
          },
          tipo: {
            type: 'select',
            options: ['Manga corta', 'Manga larga', 'Musculosa', 'Crop Top', 'Polo', 'Térmica'],
            required: true
          },
          cuello: {
            type: 'select',
            options: ['Redondo', 'En V', 'Polo', 'Escote Bote', 'Cuello alto'],
            required: true
          },
          estilo: {
            type: 'select',
            options: ['Casual', 'Urbano', 'Deportivo', 'Básico', 'Oversize'],
            multiple: true,
            required: true
          }
        },
        enabled: true
      },
      
      'CAMPERA': {
        name: 'CAMPERA',
        fields: {
          talle: {
            type: 'select',
            options: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', 'Único'],
            multiple: true,
            required: true
          },
          tipo: {
            type: 'select',
            options: ['Abrigo grueso', 'Deportiva', 'Rompeviento', 'Jean', 'Cuero', 'Inflable', 'Bomber', 'Parka', 'Impermeable'],
            required: true
          },
          material: {
            type: 'select',
            options: ['Algodón', 'Poliéster', 'Cuero', 'Eco-Cuero', 'Denim', 'Nylon', 'Lana', 'Softshell', 'Gabardina'],
            required: true
          },
          tipoCierre: {
            type: 'select',
            options: ['Cierre', 'Abotonado'],
            required: true
          },
          estilo: {
            type: 'select',
            options: ['Casual', 'Urbano', 'Deportivo', 'Formal', 'Outdoor'],
            multiple: true,
            required: true
          }
        },
        enabled: true
      },
      
      'PANTALÓN': {
        name: 'PANTALÓN',
        fields: {
          talle: {
            type: 'select',
            options: ['26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'Único'],
            multiple: true,
            required: true
          },
          tipo: {
            type: 'select',
            options: ['Jean', 'Jogger', 'Babucha', 'Sastrero', 'Deportivo', 'Cargo', 'Chupín', 'Oxford', 'Recto', 'Acampanado'],
            required: true
          },
          corte: {
            type: 'select',
            options: ['Regular Fit', 'Slim Fit', 'Wide Leg', 'Recto', 'Chupín', 'Flare'],
            required: true
          },
          tiro: {
            type: 'select',
            options: ['Alto', 'Medio', 'Bajo'],
            required: true
          },
          largo: {
            type: 'select',
            options: ['Largo', 'Corto', 'Short', 'Bermuda', '7/8', '3/4'],
            required: true
          },
          material: {
            type: 'select',
            options: ['Denim', 'Algodón', 'Gabardina', 'Poliéster', 'Lino', 'Frisa', 'Elastano'],
            required: true
          },
          estilo: {
            type: 'select',
            options: ['Casual', 'Formal', 'Urbano', 'Deportivo'],
            multiple: true,
            required: true
          }
        },
        enabled: true
      },
      
      'BUZO': {
        name: 'BUZO',
        fields: {
          talle: {
            type: 'select',
            options: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', 'Único'],
            multiple: true,
            required: true
          },
          tipo: {
            type: 'select',
            options: ['Con capucha', 'Sin capucha', 'Con cierre', 'Sin cierre', 'Deportivo', 'Casual'],
            required: true
          },
          material: {
            type: 'select',
            options: ['Algodón', 'Poliéster', 'Frisa', 'Mezcla'],
            required: true
          },
          estilo: {
            type: 'select',
            options: ['Casual', 'Urbano', 'Deportivo', 'Oversize'],
            multiple: true,
            required: true
          }
        },
        enabled: true
      },
      
      'CAMISA': {
        name: 'CAMISA',
        fields: {
          talle: {
            type: 'select',
            options: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', 'Único'],
            multiple: true,
            required: true
          },
          manga: {
            type: 'select',
            options: ['Larga', 'Corta'],
            required: true
          },
          estilo: {
            type: 'select',
            options: ['Formal', 'Casual', 'Lino', 'Jean', 'Vestir', 'Hawaiana', 'Oversize', 'Urbano', 'Vintage'],
            multiple: true,
            required: true
          },
          material: {
            type: 'select',
            options: ['Algodón', 'Lino', 'Poliéster', 'Viscosa', 'Jean', 'Mezcla'],
            required: true
          },
          corte: {
            type: 'select',
            options: ['Regular Fit', 'Slim Fit', 'Oversize'],
            required: true
          }
        },
        enabled: true
      },
      
      'SHORT': {
        name: 'SHORT',
        fields: {
          talle: {
            type: 'select',
            options: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', 'Único'],
            multiple: true,
            required: true
          },
          tipo: {
            type: 'select',
            options: ['Deportivo', 'Casual', 'Jean', 'Cargo', 'Bermuda', 'Baño'],
            required: true
          },
          largo: {
            type: 'select',
            options: ['Corto', 'Medio', 'Largo'],
            required: true
          },
          estilo: {
            type: 'select',
            options: ['Casual', 'Deportivo', 'Urbano', 'Playa'],
            multiple: true,
            required: true
          }
        },
        enabled: true
      },
      
      'VESTIDO': {
        name: 'VESTIDO',
        fields: {
          talle: {
            type: 'select',
            options: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', 'Único'],
            multiple: true,
            required: true
          },
          tipo: {
            type: 'select',
            options: ['Casual', 'Formal', 'Cóctel', 'Noche', 'Playa', 'Oficina', 'Vestido de novia'],
            required: true
          },
          largo: {
            type: 'select',
            options: ['Mini', 'Medio', 'Largo', 'Maxi'],
            required: true
          },
          estilo: {
            type: 'select',
            options: ['Clásico', 'Moderno', 'Vintage', 'Romántico', 'Minimalista'],
            multiple: true,
            required: true
          }
        },
        enabled: true
      },
      
      'POLLERA': {
        name: 'POLLERA',
        fields: {
          talle: {
            type: 'select',
            options: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', 'Único'],
            multiple: true,
            required: true
          },
          tipo: {
            type: 'select',
            options: ['Mini', 'Medio', 'Largo', 'A-line', 'Recta', 'Circular', 'Pleated'],
            required: true
          },
          estilo: {
            type: 'select',
            options: ['Casual', 'Formal', 'Oficina', 'Fiesta', 'Deportivo'],
            multiple: true,
            required: true
          }
        },
        enabled: true
      },
      
      'CALZADO': {
        name: 'CALZADO',
        fields: {
          talle: {
            type: 'select',
            options: ['35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', 'Único'],
            multiple: true,
            required: true
          },
          tipo: {
            type: 'select',
            options: ['Zapatillas', 'Zapatos', 'Botas', 'Sandalias', 'Mocasines', 'Tacones', 'Planas'],
            required: true
          },
          estilo: {
            type: 'select',
            options: ['Casual', 'Formal', 'Deportivo', 'Urbano', 'Elegante'],
            multiple: true,
            required: true
          }
        },
        enabled: true
      },
      
      'ACCESORIOS': {
        name: 'ACCESORIOS',
        fields: {
          tipo: {
            type: 'select',
            options: ['Gorra', 'Bufanda', 'Guantes', 'Cinturón', 'Cartera', 'Bolso', 'Reloj', 'Gafas', 'Collar', 'Pulsera', 'Anillo'],
            required: true
          },
          estilo: {
            type: 'select',
            options: ['Casual', 'Formal', 'Deportivo', 'Elegante', 'Vintage'],
            multiple: true,
            required: true
          }
        },
        enabled: true
      }
    };

    // Campos globales para todos los productos
    const globalFields = {
      sku: {
        type: 'text',
        generated: true,
        required: true
      },
      stock: {
        type: 'number',
        format: 'thousands',
        required: true
      },
      precioCompra: {
        type: 'currency',
        symbol: '$',
        format: 'thousands',
        required: true
      },
      precioVenta: {
        type: 'currency',
        symbol: '$',
        format: 'thousands',
        required: true
      },
      color: {
        type: 'text',
        required: true
      },
      marca: {
        type: 'text',
        required: true
      },
      proveedor: {
        type: 'text',
        required: true
      },
      descripcion: {
        type: 'textarea',
        required: false
      },
      tags: {
        type: 'text',
        multiple: true,
        required: false
      },
      activo: {
        type: 'boolean',
        default: true,
        required: true
      }
    };

    // Crear cada categoría
    for (const [categoryName, categoryData] of Object.entries(allCategories)) {
      console.log(`📂 Creando categoría: ${categoryName}`);
      
      // Agregar campos globales a cada categoría
      const completeCategoryData = {
        ...categoryData,
        fields: {
          ...categoryData.fields,
          ...globalFields
        },
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp()
      };
      
      // Crear documento principal de la categoría
      const categoryRef = doc(db, 'users', userId, 'categories', categoryName);
      await setDoc(categoryRef, completeCategoryData);
      
      // Crear documento placeholder en /stock/ para mantener la estructura
      const stockRef = doc(db, 'users', userId, 'categories', categoryName, 'stock', '.placeholder');
      await setDoc(stockRef, {
        _placeholder: true,
        message: 'Esta carpeta contiene los productos de la categoría',
        createdAt: serverTimestamp()
      });
      
      console.log(`✅ Categoría "${categoryName}" creada con estructura completa`);
    }
    
    console.log('🎉 Las 10 categorías completas creadas exitosamente');
    console.log('📋 Categorías creadas:');
    Object.keys(allCategories).forEach(cat => console.log(`   - ${cat}`));
    console.log('📋 Estructura:');
    console.log('   - Colección: users/{userId}/categories/');
    console.log('   - Documentos: users/{userId}/categories/{CATEGORY_NAME}');
    console.log('   - Stock: users/{userId}/categories/{CATEGORY_NAME}/stock/');
    console.log('   - Productos: users/{userId}/categories/{CATEGORY_NAME}/stock/{SKU}');
    
    return {
      success: true,
      message: 'Las 10 categorías completas creadas exitosamente',
      categories: Object.keys(allCategories)
    };
    
  } catch (error) {
    console.error('❌ Error creando categorías:', error);
    return {
      success: false,
      error: error instanceof Error ? error.message : error
    };
  }
};

console.log('🔧 Script de 10 categorías completas cargado');
console.log('💡 Usa: window.createAll10Categories()');
